var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as _ from "lodash";
import { Messages } from 'primereact/messages';
import * as React from "react";
import { connect } from "react-redux";
import * as RitualFactory from "../../classes/definitions/ritual/ritual";
import ApiRequests from "../../classes/http/ApiRequests";
import HttpRequests from "../../classes/http/HttpRequests";
import RitualsList from '../../components/Rituals/RitualsList/RitualsList';
import AppRoutes from '../../config/appRoutes';
import RitualsReduxProps from "./RitualsReduxProps";
var Rituals = /** @class */ (function (_super) {
    __extends(Rituals, _super);
    function Rituals() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.messages = null;
        _this.staticPageId = '';
        _this.brandId = '';
        _this.state = {
            data: []
        };
        _this.getAllRituals = function () {
            _this.api.getRituals()
                .then(function (response) {
                var data = RitualFactory.createRituals(response.data);
                _this.setState({ data: data });
            })
                .catch(function (error) {
                _this.http.handleError(error, _this.messages, 'Не можахме да заредим ритуалът', _this.props.history);
            });
        };
        _this.toNewRitual = function () {
            _this.props.history.push(AppRoutes.ritual.path);
        };
        // Deleting the item from the state
        _this.deleteItem = function (id) {
            var data = __spreadArrays(_this.state.data);
            var result = data.find(function (item) {
                return item.Id === id;
            });
            var index = data.indexOf(result);
            data.splice(index, 1);
            _this.setState({ data: data });
        };
        return _this;
    }
    Rituals.prototype.componentDidMount = function () {
        this.staticPageId = _.get(this.props, 'match.params.staticPageId', '-1');
        this.brandId = _.get(this.props, 'match.params.brandId', '-1');
        this.getAllRituals();
    };
    Rituals.prototype.render = function () {
        var _this = this;
        var data = this.state.data;
        return (React.createElement("div", { className: "container-fluid" },
            React.createElement("div", { className: "animated fadeIn" },
                React.createElement("h1", { className: "display-3" }, "\u0420\u0438\u0442\u0443\u0430\u043B\u0438"),
                React.createElement("hr", null),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement("div", { className: "list-actions" },
                            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.toNewRitual, type: "button" },
                                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                                " \u041D\u043E\u0432\u0430 \u0440\u0438\u0442\u0443\u0430\u043B")),
                        React.createElement(Messages, { ref: function (el) { _this.messages = el; } }),
                        React.createElement(RitualsList, { gridData: data, messages: this.messages, deleteItem: this.deleteItem }))))));
    };
    return Rituals;
}(React.Component));
export default connect(null, RitualsReduxProps.mapDispatchToProps)(Rituals);



//////////////////
// WEBPACK FOOTER
// ./src/views/Rituals/Rituals.tsx
// module id = 443
// module chunks = 0